import { style } from "@vanilla-extract/css";
import { calc } from "@vanilla-extract/css-utils";
import { breakpoints } from "../styles/breakpoints";
import { vars } from "../styles/theme.css";

export const pagePadding = style({
  margin: `${vars.space.m} 0`,
  padding: `0 ${vars.space.xs}`,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      padding: `0 ${vars.space.m}`,
    },
  },
});

export const leftSidebarLayout = style([
  {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: vars.space.m,
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 2fr)",
      },
    },
  },
  pagePadding,
]);

export const rightSidebarLayout = style([
  {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: vars.space.m,
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        gridTemplateColumns: "minmax(0, 2fr) minmax(0,1fr)",
      },
    },
  },
  pagePadding,
]);

export const contentMain = style({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

export const squadMain = style({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      order: 2,
    },
  },
});

export const squadSidebar = style({
  display: "none",
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      display: "block",
      order: 1,
    },
  },
});

export const squadSheet = style({
  display: "block",
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: { display: "none" },
  },
});

export const entryEventMain = style([
  contentMain,
  {
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        gridColumnStart: 2,
        order: 2,
      },
    },
  },
]);

export const statusMain = style({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  order: 2,
  gap: vars.space.m,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      gridColumnStart: 2,
    },
  },
});

export const homeSteps = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  },
});

export const homeStep = style({
  display: "flex",
});

export const homeImageContainer = style({
  marginTop: calc.negate(vars.space.m),
  marginInlineStart: calc.negate(vars.space.m),
  marginInlineEnd: calc.negate(vars.space.m),
});

export const homeImage = style({
  borderRadius: `${vars.radii.l} ${vars.radii.l} 0 0`,
  width: "100%",
});

export const statusSidebar = style([
  contentMain,
  {
    order: 1,
  },
]);

export const maxWidthContainer = style({
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  maxWidth: breakpoints[7],
});

export const historyMain = style({
  order: 1,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      order: 2,
    },
  },
});

export const historySidebar = style({
  order: 2,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      order: 1,
    },
  },
});
